var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.086,
    height: 18.798,
    viewBox: "0 0 18.086 18.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Bell_3378437",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_69",
    "data-name": "group 69",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_172",
    "data-name": "path 172",
    d: "M10.953,1.543a5.551,5.551,0,0,1,4.081,5.164,8.626,8.626,0,0,0,2.678,6.826,1.414,1.414,0,0,1-.956,2.552H1.706A1.414,1.414,0,0,1,.75,13.534,8.626,8.626,0,0,0,3.428,6.708,5.551,5.551,0,0,1,7.509,1.543,1.651,1.651,0,0,1,9.231,0,1.651,1.651,0,0,1,10.953,1.543Z",
    transform: "translate(-0.188 0)",
    fill: "#5a5a5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_173",
    "data-name": "path 173",
    d: "M96.14,281A3.258,3.258,0,0,1,90,281Z",
    transform: "translate(-84.027 -264.371)",
    fill: "#5a5a5a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.88b626b83ac9ea0f4e4e2b3ad665ce2a.svg";
export { ForwardRef as ReactComponent };